var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "D17130EE-E70E-4182-B821-A4466914EE36") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 0C4.925 0 0 4.925 0 11s4.925 11 11 11 11-4.925 11-11c0-6.076-4.925-11-11-11zm7.348 13.668c-.08.998-.839 2.271-1.898 2.456-3.393.263-7.414.23-10.929 0-1.096-.138-1.817-1.46-1.898-2.456-.17-2.094-.17-3.287 0-5.381.081-.996.82-2.31 1.898-2.43 3.474-.292 7.518-.23 10.93 0 1.219.045 1.816 1.302 1.897 2.3.168 2.094.168 3.417 0 5.511z",
    fill: "#CD201F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD201F",
    fillRule: "nonzero",
    d: "M9.487 13.981l4.494-2.996-4.494-2.996z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1-1h24v24H-1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeAlt);
export default __webpack_public_path__ + "static/media/youtube-alt.534e457f71d44781dbc4e62489115d14.svg";
export { ForwardRef as ReactComponent };